import { render, staticRenderFns } from "./CommForm.vue?vue&type=template&id=2eb9c1ba&"
import script from "./CommForm.vue?vue&type=script&lang=js&"
export * from "./CommForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports